import IEnvironment from './IEnvironment';

const env: IEnvironment = {
    production: false,
    mapa: {
        contexto: 'sqfi',
        ambiente: 'Desenvolvimento',
        wso2Url: 'https://servicedesenv.agricultura.gov.br:443/',
        debug: true,
        idiomas: [
            {
                code: 'pt-br',
                name: 'Português'
            }
        ]
    }
};

export const environment = env;
